import Vue from 'vue'
import Vuex from 'vuex'
// import url from "../common/api";
let url={}
url.baseUrl='/qiapi'
// url.baseUrl='http://192.168.0.51:8000'
// url.baseUrl='http://119.3.233.219:8009'
// url.baseUrl='/api'

import tagsView from './modules/tagsView' // 新增tagsView
import settings from './modules/settings'
import app from './modules/app'
import getters from './getters'
Vue.use(Vuex)
export default new Vuex.Store({
    state:{
        user_id:'',
        userInfo:{},//用户信息存储
        static:url.baseUrl+'/static/upload/',//图片访问地址
        uploadimage:url.baseUrl+'/one/uploadimage/',//图片富文本编辑上传地址
        code_image_url:url.baseUrl+'/verification/image_codes/img_',//验证码地址
        tagList:[//规定的主题种类
            '汽轮机',
            '燃气轮机',
            '冶金',
            '化工',
            '造纸',
            'AR/VR',
            '物联网',
            '智慧能源',
            '能源',
            '新能源',
            '垃圾焚烧',
            '航改机',
            '压缩机',
            '焦化',
            '有色金属',
            '煤化',
            '机器人',
            '3D仿真',
            '智能电网',
            '天然气',
            '环保',
            '污水处理',
        ],
        tagDialogList:[//规定的主题种类
            '汽轮机',
            '燃气轮机',
            '冶金',
            '化工',
            '造纸',
            '航改机',
            '压缩机',
            '焦化',
            '有色金属',
            '煤化',
            'AR/VR',
            '物联网',
            '智慧能源',
            '能源',
            '新能源',
            '垃圾焚烧',
            '机器人',
            '3D仿真',
            '智能电网',
            '天然气',
            '环保',
            '污水处理',
        ],
        buserInfo:{},//后台--用户信息存储
        companyname:'无',//公司名称
        SubDownloadoptions:[{// 下载中心可以有children，但不能为空
            id: 11,
            value: '宣传资料',
            label: '宣传资料',
            }, {
            id: 21,
            value: '软件下载',
            label: '软件下载',
        }, {
            id: 31,
            value: '视频资料',
            label: '视频资料',
        }, {
            id: 41,
            value: '其他',
            label: '其他',
        }],//下载中心目录
        FileLists:[],//工程师提交的文件列表
        userProjectId:'',
        paramChartcategorys:[{
            value: '温度',
            label: '温度'
            }, {
            value: '流量',
            label: '流量'
            }, {
            value: '压力',
            label: '压力'
            }, {
            value: '开度',
            label: '开度'
            }, {
            value: '频率',
            label: '频率'
            },{
            value: '功率',
            label: '功率'
            }, {
            value: '电流',
            label: '电流'
            }, {
            value: '位移',
            label: '位移'
            }, {
            value: '转速',
            label: '转速'
            }, {
            value: '振动',
            label: '振动'
            }, {
            value: '膨胀',
            label: '膨胀'
            },{
            value: '胀差',
            label: '胀差'
            },{
            value: '液位',
            label: '液位'
            },{
            value: '速度',
            label: '速度'
            },{
            value: '开关量',
            label: '开关量'
            }]
    },
    mutations:{
        setUser_id(state,change){
            state.user_id=change
        },
        setuserInfo(state,change){//获取用户信息
            state.userInfo=change
        },
        setcompanyname(state,change){//公司名称
            state.companyname=change
        },
        setBuserInfo(state,change){//获取后台用户信息
            state.buserInfo=change
        },
        setFileLists(state,change){//添加工程师提交的文件列表
            state.FileLists=change
        },
        DelMBuserInfo(state,change){//删除后台登录信息
            state.buserInfo={}
        },
        DelMuserInfo(state,change){//删除前台登录信息
            state.userInfo={}
        },
        USERProjectId(state,Pid){ //改变选中的id
            state.userProjectId=Pid
        }
    },
    actions:{
        getUser_id(state,change){
            state.commit('setUser_id',change)
        },
        getuserInfo(state,change){//获取用户信息
            state.commit('setuserInfo',change)
        },
        getcompanyname(state,change){//公司名称
            state.commit('setcompanyname',change)
        },
        getBuserInfo(state,change){//获取后台用户信息
            state.commit('setBuserInfo',change)
        },
        getFileLists(state,change){//添加工程师提交的文件列表
            state.commit('setFileLists',change)
        },
        DelABuserInfo(state,change){//删除后台登录信息
            sessionStorage.removeItem('bkL');
            state.commit('DelMBuserInfo',change)
        },
        DelAuserInfo(state,change){//删除前台登录信息
            sessionStorage.removeItem('logi');
            state.commit('DelMuserInfo',change)
        },
        UserProjectId(state,Pid){//触发改变选中的id的事件
            state.commit('USERProjectId',Pid)
        }
    },
    modules: {
        app,
        settings,
        tagsView // 新增tagsView
    },
    getters

})


// WEBPACK FOOTER //
// ./src/store/index.js